import { useSalesPlanMarketingOrg } from '@/entities/dorim-promo';
import {
  BreadcrumbLink,
  DorimPromoPaths,
  LazyBreadcrumb,
  type RouteObjectWithBreadcrumbs,
  type SpecificationDetailSalesPlanProductViewPathParams,
} from '@/shared/lib/react-router';

export const SalesPlanProductsPageRoute: RouteObjectWithBreadcrumbs = {
  path: DorimPromoPaths.SPECIFICATION_DETAIL_SALES_PLAN_PRODUCT_VIEW_PATH,
  handle: {
    breadcrumb: (params: SpecificationDetailSalesPlanProductViewPathParams) => ({
      Component: () => {
        const { data, isLoading } = useSalesPlanMarketingOrg({
          agreement_id: Number(params.specificationId),
          marketing_org_id: Number(params.marketingOrgId),
        });

        return (
          <LazyBreadcrumb isLoading={isLoading}>
            <BreadcrumbLink to={DorimPromoPaths.generateMarketingOrgDetailPath(params)}>
              {data?.marketing_org_details?.marketing_org?.full_name || 'Маркетирующая организация'}
            </BreadcrumbLink>
          </LazyBreadcrumb>
        );
      },
    }),
  },
  lazy: async () => {
    const { SalesPlanProductsPage } = await import(
      /* webpackChunkName: "SalesPlanProductsPage" */
      './SalesPlanProductsPage'
    );

    return {
      Component: SalesPlanProductsPage,
    };
  },
};
